import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const Badge = styled.div`
  background-color: ${color.light};
  border: 0.8px solid #f14747;
  border-radius: 2px;
  color: ${color.sunsetOrange};
  display: inline-block;
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  padding: 0px 5px;
  position: relative;
  vertical-align: middle;

  > span {
    font-style: normal;
    font-family: var(--bold-font);
    line-height: 12px;
  }
`;
